// src/About.js
import React from 'react';
import './About.css'; // Import the CSS file for the About page

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2 className="about-title">About Us</h2>
        <div className="about-content">
          <p className="about-paragraph">
            SimplyIgbo is an Igbo learning academy that is fully online, dedicated to helping families and individuals learn the Igbo language and speak it fluently, fast. Our courses are designed to help learners master Igbo by promoting conversations and situating learning within cultural contexts.
          </p>
          <h3 className="about-subtitle">Mission:</h3>
          <p className="about-paragraph">
            Our mission is to empower individuals and families to connect with their heritage and culture by providing accessible, immersive, and interactive online courses that foster fluent Igbo language skills and cultural understanding.
          </p>
          <h4 className="about-subsubtitle">Our Vision:</h4>
          <p className="about-paragraph">
            Our vision is to be the global leader in Igbo language education.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;